import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import lock from '../assets/lockk.png';
import demo from '../assets/video_demo.mp4';
import daniel from '../assets/daniel.png';
import emily from '../assets/emily.png';
import rachel from '../assets/rachel.jpg';

const Home = () => {

  const videoRef = useRef(null);

useEffect(() => {
  if (videoRef.current) {
    videoRef.current.play().catch(err => {
      console.warn("Autoplay blocked:", err);
    });
  }
}, []);

  return (
    <div className="home">
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>AI-Powered Case Interviews</h1>
            <p className="hero-subtitle">
              Practice with our cutting-edge AI assistant to ace your consulting case interviews
            </p>
            <div className="hero-buttons">
              <Link to="/interview-config" className="button-primary">Practice Case Interview</Link> 
              <Link to="/" className="button-outline">View Pricing </Link>
            </div>
            <video
              ref={videoRef}
              className="demo-video"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={demo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose Hawl Technologies</h2>
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-robot"></i>
              </div>
              <h3>Advanced AI</h3>
              <p>Our AI assistant provides realistic case scenarios and feedback just like a real interviewer</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>Improve Skills</h3>
              <p>Develop critical thinking and problem-solving abilities essential for consulting roles</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Track Progress</h3>
              <p>Monitor your improvement over time with detailed performance analytics</p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials">
          <div className="container">
            <h2 className="testimonials-title">Hear From Our Users</h2>
            <div className="testimonials-grid">
              <div className="testimonials-card">
                <div className="testimonials-icon">
                  <img className="testimonials-icon" src={emily} alt="Emily T."></img>
                </div>
                <h3>Emily T.</h3>
                <h4>Student @ University of Michigan</h4>
                <p>“As a final-year student applying for consulting roles, I was overwhelmed by case prep. This platform gave me instant feedback on my case answers, helped me improve my structure, and gave me the confidence I needed. I landed an offer at BCG—thank you!”</p>
              </div>

              <div className="testimonials-card">
                <div className="testimonials-icon">
                  <img className="testimonials-icon" src={daniel} alt="Daniel R."></img>
                </div>
                <h3>Daniel R.</h3>
                <h4>Product Manager turned Consultant</h4>
                <p>“I was moving from tech into consulting and didn’t know where to start. The AI coach simulated real interviews and taught me how to think like a consultant. Way more efficient than any book or peer practice. I cracked my Accenture final round!”</p>
              </div>

              <div className="testimonials-card">
                <div className="testimonials-icon">
                  <img className="testimonials-icon" src={rachel} alt="Rachel Z."></img>
                </div>
                <h3>Rachel Z.</h3>
                <h4>Consultant, ex-PE Analyst</h4>
                <p>“I didn’t have time to book mock interviews. Practicing on-demand with the AI interviewer saved me hours and helped me focus on my weak points. I got three offers—can’t recommend this enough.”</p>
              </div>
            </div>
          </div>
      </section>

      <section className="cta-section bg-gradient">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to ace your case interviews?</h2>
            <p>Join thousands of successful candidates who prepared with our AI assistant</p>
            <Link to="/interview-config" className="cta-button">Start Practicing Now</Link>
          </div>
        </div>
      </section>
      <div className="Keywords-add" style={{fontSize:"2px", color:"white" }}>
      Career Counselling,Case study
      Mock interview
      Accenture
      Bain & Company
      BCG Gamma
      McKinsey
      Oliver Wyman
      Management consultant
      Porter's Five Forces, SWOT analysis, and market sizing
      Big4
      Big3
      Deloitte, KPMG, PWC, EY
      Consulting interview
      </div>
    </div>
  
  );
};

export default Home; 